import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronRight } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const MobileSidebar = ({ isOpen, onClose }) => {
  const categories = [
    {
      name: 'MANGA',
      subcategories: ['Shōnen', 'Shōjo', 'Seinen', 'Kodomo', 'Todas las series']
    },
    {
      name: 'CÓMICS',
      subcategories: ['Marvel', 'DC Comics', 'Image', 'Dark Horse', 'Todos los cómics']
    },
    {
      name: 'ARTBOOKS',
      subcategories: ['Anime', 'Videojuegos', 'Ilustración', 'Concept Art', 'Todos los artbooks']
    },
    { name: 'JUEGOS' },
    { name: 'LIBROS' },
    { name: 'MERCHANDISING' }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
          />

          {/* Sidebar */}
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="fixed top-0 left-0 h-full w-80 bg-background shadow-xl z-50 lg:hidden overflow-y-auto"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-border">
              <h2 className="text-lg font-bold text-primary">La Orda</h2>
              <button
                onClick={onClose}
                className="p-2 hover:bg-muted rounded-full transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Navigation */}
            <div className="p-4">
              <Accordion type="single" collapsible className="w-full">
                {categories.map((category, index) => (
                  category.subcategories ? (
                    <AccordionItem key={index} value={`item-${index}`}>
                      <AccordionTrigger className="text-sm font-medium">
                        {category.name}
                      </AccordionTrigger>
                      <AccordionContent>
                        <ul className="space-y-2 pl-4">
                          {category.subcategories.map((sub, subIndex) => (
                            <li key={subIndex}>
                              <a
                                href="#"
                                className="text-sm text-muted-foreground hover:text-primary transition-colors block py-2"
                                onClick={onClose}
                              >
                                {sub}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </AccordionContent>
                    </AccordionItem>
                  ) : (
                    <a
                      key={index}
                      href="#"
                      className="flex items-center justify-between py-4 border-b border-border text-sm font-medium hover:text-primary transition-colors"
                      onClick={onClose}
                    >
                      {category.name}
                      <ChevronRight className="w-4 h-4" />
                    </a>
                  )
                ))}
              </Accordion>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default MobileSidebar;